const rules = {
  LOGISTICS_ADMIN: {
    static: [
      '/',
      '/login',
      '/nonPost-orders',
      'orderExit:print',
      'orders-detail:postOrders',
      '/nonPost-orders/:id',
      'orders:list:status',
      // 'orders:list:centerName',
      // IF ANY PROBLEMS ARISE, CHANGE THIS, RECEIPT
      '/all-orders',
      '/vip-orders',
      '/vip-orders/:id',
      '/vvip-orders',
      '/vvip-orders/:id',
      '/post-orders',
      '/post-print-labels/:id',
      //'/post-orders-queue',
      '/post-orders/:id/send',
      '/post-orders/post-receipt',
      '/orders/:id',
      '/orders/:id/allLogs',
      '/3pl-print-labels',
      'orders:changeOrderStatus',
      'orders:byBundle',
      'orders:history',
      'orders:btnSendPostOrders',
      'orders:downloadReportCSV',
      'orders:cancelOrders',
      'orders:post-tracking-code',
      '/vip-orders/3pl-orders/:id',
      '/nonPost-orders/3pl-orders/:id',
      // '/post-orders-3pl/:id',
      //'/post-orders/receipts/:id',
      '/orders/post/exit-receipts',
      '/orders/exit-receipts/:id',
      '/create-grouping-3PL',
      'bundles:changeStatus',
      '/pickups',
      '/pickups/details/:id',
      '/parcels/:id/allLogs',
      '/pickups/assignment/:id',
      '/fleets',
      '/fleets/:id/drivers',
      'drivers:downloadReportCSV',
      '/drivers',
      '/bundles',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      '/create-bundle',
      '/edit-bundle/:id',
      'bundles:add',
      'bundles:add-exel',
      'bundles:history',
      'bundles:edit',
      'bundles:cancel',
      '/fleets/:id/drivers/create',
      '/fleets/:fleetId/drivers/:id/edit',
      '/drivers/:id/shifts/:shiftId',
      '/deliver-ronad-orders',
      '/create-bundle-with-excel',
      '/post-list',
      '/pickups/details/receipt/:id',
      '/profile',
      '/deliver/receipts/:id',
      '/deliver-driver-receipt/:id',
      '/ticketing',
      '/ticketing/:id',
      '/assignments'
    ],
  },
  SECURITY_ADMIN: {
    static: [
      '/security',
      '/security/active-drivers',
      '/security/traffic-history',
      '/security/add-driver',
      '/profile',
    ],
  },
  NONE: {
    static: ['/login'],
  },
};

export default rules;
